<div fxLayout="column" fxFlexFill [ngStyle]="{'max-height.px': innerHeight}">

    <div class="scrolled fill-rest" style="overflow-x: hidden;">

        <div id="Zone_Widget" #mrWidget></div>

        <div id="selectedrelaycomp" class="layout-padd" *ngIf="selectedRelay" fxLayout="column" fxLayoutGap="10px">

            <div>
                <span class="mat-caption">{{'mondialRelayComponent.selected'|translate}} </span>
            </div>

            <div class="layout-padd bordered-card" fxLayout="column">
                <div> <span class="mat-subheading-1">{{selectedRelay.Nom}}</span></div>
                <div fxLayout="row" fxLayoutGap="5px">
                    <div> <span class="mat-subheading-1">{{selectedRelay.CP | capitalize}}</span> </div>
                    <div> <span class="mat-subheading-1">-</span></div>
                    <div> <span class="mat-subheading-1">{{selectedRelay.Ville | capitalize}}</span></div>
                </div>
                <div> <span class="mat-subheading-1">{{selectedRelay.Adresse1 | capitalize}}</span> </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" fxHide.xs>
                <button mat-stroked-button (click)="closeDial()" fxFlex>Retour</button>
                <button mat-stroked-button color="accent" (click)="selectRelay()" [disabled]="!selectedRelay" fxFlex>{{'mondialRelayComponent.confirm'|translate}}</button>
            </div>

        </div>

    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" class="layout-padd" fxHide fxShow.xs>
        <button mat-stroked-button (click)="closeDial()" fxFlex>Retour</button>
        <button mat-stroked-button color="accent" (click)="selectRelay()" [disabled]="!selectedRelay" fxFlex>{{'mondialRelayComponent.confirm'|translate}}</button>
    </div>


    <!-- 
    <div id="Zone_Widget" #mrWidget></div>

    <div id="selectedrelaycomp" class="layout-padd" *ngIf="selectedRelay" fxLayout="column" fxLayoutGap="10px">

        <div>
            <span class="mat-caption">Relais selectionné: </span>
        </div>

        <mat-card fxLayout="column">
            <div> <span class="mat-subheading-1">{{selectedRelay.Nom}}</span></div>
            <div fxLayout="row" fxLayoutGap="5px">
                <div> <span class="mat-subheading-1">{{selectedRelay.CP | capitalize}}</span> </div>
                <div> <span class="mat-subheading-1">-</span></div>
                <div> <span class="mat-subheading-1">{{selectedRelay.Ville | capitalize}}</span></div>
            </div>
            <div> <span class="mat-subheading-1">{{selectedRelay.Adresse1 | capitalize}}</span> </div>
        </mat-card>

        <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-raised-button color="primary" (click)="selectRelay()" [disabled]="!selectedRelay">Confirmer</button>
        </div>

    </div> -->

</div>